module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/bigben-568e84acd1fee8f021e7acffa5d2c950.png";